import { makeStyles } from '@material-ui/core/styles';
import OverViewManagerIpadImage from '@assets/overview-manager-ipad.png';
import ContainerBackgroundImage from '@assets/new-overview-initial-bg-2.svg';
const useStyles = makeStyles(({ breakpoints, variables, palette }) => ({
  managerInitialContentContainer: {
    background:`url(${ContainerBackgroundImage}) no-repeat`,
    backgroundColor: palette?.jet?.containerDark,
    backgroundPosition: '-766px -389px',
    backgroundSize: '1949px 1170px',
    position:'relative',
    height: '620px',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '125px',
    [breakpoints.down('xs')]:{ 
        backgroundImage: 'none',
        paddingTop:variables?.spacingG,
        height: '432px',
    }
  },
  managerInitialContent: {
    color: palette?.jet?.containerDefault,
    width: '900px',
    paddingLeft:variables?.spacingD,
    paddingRight:variables?.spacingD,
    zIndex:1,
    [breakpoints.down('xs')]:{ 
      width: '100%',
      paddingLeft:variables?.spacingF,
      paddingRight:variables?.spacingF
    },
    '& .manager-initial-content-title':{
      [breakpoints.down('xs')]:{ 
        marginBottom:variables?.spacingC
      }
    },
    '& .jetButton': {
      width:'auto !important',
      minWidth:'257px !important',
      paddingLeft:variables?.spacingC,
      paddingRight:variables?.spacingC,
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: variables?.spacingE,
      [breakpoints.down('xs')]:{ 
        marginBottom:variables?.spacingG,
        display:'unset',
        minWidth:'186px !important',
      }
    },
    '& .content-image': {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: `${variables?.spacingD}`,
      width: '545px',
      height: '393px',
      background:`url(${OverViewManagerIpadImage})`,
      backgroundSize:'cover',
      padding:variables?.spacingE,
      '& img': {
        [breakpoints.down('xs')]:{
          width:'100%',
          height:'100%',
        },
        borderRadius:variables?.radiusRoundedB,
        pointerEvents:'none'
      },
      [breakpoints.down('xs')]:{ 
       width:'285px',
       height:'206px',
       marginTop:variables?.spacingD,
       padding:variables?.spacingC
      }
    },
  },
}));

export default useStyles;
